'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _transition = require('../utils/transition.js');

var _dom = require('../utils/dom.js');

var _arrow_up = require('./imgs/arrow_up');

var _arrow_up2 = _interopRequireDefault(_arrow_up);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  inject: ['_activeData'],
  props: {
    collapsed: {
      type: Boolean,
      default: true
    },
    name: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      collapsed_: this.collapsed,
      bodyHeight: 0,
      activeName: 0,
      arrowUp: _arrow_up2.default
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var dom = weex.requireModule('dom');
      (0, _dom.getBoundingClientRect)(dom, _this.$refs.slotBody, function (res) {
        if (res.result) {
          _this.bodyHeight = res.size.height;
        }
        if (_this.collapsed_) {
          _this.collapseBody(0);
        }
      }, 0);
    });
    if (this.collapsed_) {
      this.collapseArrow(0);
    }
  },

  computed: {
    accordion: function accordion() {
      return this._activeData.accordion;
    },
    isHarmony: function isHarmony() {
      return weex.config.env.platform == 'harmony';
    }
  },
  watch: {
    _activeData: {
      handler: function handler(newValue, oldValue) {
        this.activeName = newValue._activeName;
        if (newValue._activeName != -1) {
          //手风琴
          if (newValue._activeName == 0) {
            this.collapseBody();
            this.collapseArrow();
            this.collapsed_ = true;
          } else {
            if (newValue._activeName != this.name) {
              this.collapseBody();
              this.collapseArrow();
              this.collapsed_ = true;
            } else {
              if (this.collapsed_) {
                this.collapseBody();
                this.collapseArrow();
              } else {
                this.expandeBody();
                this.expandeArrow();
              }
            }
          }
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    onCollapseHandler: function onCollapseHandler() {
      var _this2 = this;

      if (this.isHarmony) {
        if (this.clickLock) return;
        this.clickLock = true;
      }
      this.collapsed_ = !this.collapsed_;
      //手风琴-发送通知
      this.$parent.collapseClick({ collapsed: this.collapsed_, name: this.name });
      if (!this.accordion) {
        if (this.collapsed_) {
          this.collapseBody();
          this.collapseArrow();
        } else {
          this.expandeBody();
          this.expandeArrow();
        }
      }
      if (this.isHarmony) {
        setTimeout(function () {
          _this2.clickLock = false;
        }, 100);
      }
    },
    collapseBody: function collapseBody() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 360;

      _transition.Transition.Default().duration(duration).height(0).needLayout(true).run(this.$refs.slotBody);
    },
    collapseArrow: function collapseArrow() {
      _transition.Transition.Default().rotateZ(-180).transformOrigin('center').run(this.$refs.arrow);
    },
    expandeBody: function expandeBody() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 360;

      _transition.Transition.Default().duration(duration).height(this.bodyHeight).needLayout(true).run(this.$refs.slotBody);
    },
    expandeArrow: function expandeArrow() {
      _transition.Transition.Default().rotateZ(0).transformOrigin('center').run(this.$refs.arrow);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-collapse-item/index.vue
// module id = 324
// module chunks = 0 1